export default __webpack_public_path__ + "static/media/fix_icon.5f8f2a98.svg";